import React, { useState, useEffect } from 'react';
import { Container, Box, Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Chip, Dialog, DialogTitle, DialogContent, DialogActions, TextField, MenuItem, CircularProgress } from '@mui/material';
import { Add, Check, Block, Edit, Delete } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import ModuleHeader from '../../components/ModuleHeader';
import api from '../../axios';
import { errorMsg } from '../../utils/errorMsg';

function parseTipo() {
  try { const t = localStorage.getItem('token'); return JSON.parse(atob(t.split('.')[1])).tipo; } catch { return ''; }
}

export default function GruposDiscipuladoLista() {
  const navigate = useNavigate();
  const [grupos, setGrupos] = useState([]);
  const [discipuladores, setDiscipuladores] = useState([]);
  const [loading, setLoading] = useState(true);
  const [erro, setErro] = useState('');
  const [dialog, setDialog] = useState(false);
  const [editando, setEditando] = useState(null);
  const [form, setForm] = useState({ nome: '', descricao: '', discipulador_id: '', observacoes: '' });
  const tipo = parseTipo();
  const podeAprovar = ['pastor', 'admin_tenant', 'super_admin'].includes(tipo);

  const carregar = async () => {
    setLoading(true); setErro('');
    try {
      const [g, d] = await Promise.all([api.get('/grupos-discipulado'), api.get('/secretaria/membros')]);
      setGrupos(g.data); setDiscipuladores(d.data);
    } catch (e) { setErro(errorMsg(e) || 'Erro ao carregar'); }
    setLoading(false);
  };
  useEffect(() => { carregar(); }, []);

  const abrirNovo = () => { setEditando(null); setForm({ nome: '', descricao: '', discipulador_id: '', observacoes: '' }); setDialog(true); };
  const abrirEditar = (g) => { setEditando(g); setForm({ nome: g.nome, descricao: g.descricao || '', discipulador_id: g.discipulador_id || '', observacoes: g.observacoes || '' }); setDialog(true); };
  const salvar = async () => {
    try {
      const payload = { nome: form.nome, descricao: form.descricao, discipulador_id: Number(form.discipulador_id), observacoes: form.observacoes };
      if (editando) await api.put(`/grupos-discipulado/${editando.id}`, payload);
      else await api.post('/grupos-discipulado', payload);
      setDialog(false); carregar();
    } catch (e) { setErro(errorMsg(e) || 'Erro ao salvar'); }
  };
  const aprovar = async (id) => { try { await api.post(`/grupos-discipulado/${id}/aprovar`); carregar(); } catch (e) { setErro(errorMsg(e)); } };
  const reprovar = async (id) => { try { await api.post(`/grupos-discipulado/${id}/reprovar`); carregar(); } catch (e) { setErro(errorMsg(e)); } };
  const excluir = async (id) => { if (!window.confirm('Excluir este grupo?')) return; try { await api.delete(`/grupos-discipulado/${id}`); carregar(); } catch (e) { setErro(errorMsg(e)); } };

  const corStatus = { pendente: 'warning', aprovado: 'success', reprovado: 'error' };

  return (
    <Container maxWidth="lg" sx={{ py: { xs: 2, md: 4 }, px: { xs: 1, md: 2 } }}>
      <ModuleHeader module="Discipulado" title="Grupos de Discipulado" />
      {erro && <Box sx={{ color: 'error.main', mb: 2 }}>{erro}</Box>}
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2 }}>
        <Button variant="contained" startIcon={<Add />} onClick={abrirNovo}>Novo grupo</Button>
      </Box>
      {loading ? <CircularProgress /> : (
        <TableContainer component={Paper}>
          <Table size="small">
            <TableHead><TableRow>{['Nome', 'Discipulador', 'Status', 'Ações'].map(h => <TableCell key={h} sx={{ fontWeight: 700 }}>{h}</TableCell>)}</TableRow></TableHead>
            <TableBody>
              {grupos.map(g => (
                <TableRow key={g.id} hover>
                  <TableCell><strong>{g.nome}</strong></TableCell>
                  <TableCell>{g.discipulador_nome || '-'}</TableCell>
                  <TableCell><Chip size="small" color={corStatus[g.status] || 'default'} label={g.status} /></TableCell>
                  <TableCell>
                    <Box sx={{ display: 'flex', gap: 0.5 }}>
                      {podeAprovar && g.status === 'pendente' && (
                        <><Button size="small" color="success" variant="contained" onClick={() => aprovar(g.id)}>Aprovar</Button>
                        <Button size="small" color="warning" variant="outlined" onClick={() => reprovar(g.id)}>Reprovar</Button></>
                      )}
                      <Button size="small" onClick={() => abrirEditar(g)}><Edit fontSize="small" /></Button>
                      <Button size="small" color="error" onClick={() => excluir(g.id)}><Delete fontSize="small" /></Button>
                    </Box>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}

      <Dialog open={dialog} onClose={() => setDialog(false)} maxWidth="sm" fullWidth>
        <DialogTitle>{editando ? 'Editar grupo' : 'Novo grupo'}</DialogTitle>
        <DialogContent>
          <TextField fullWidth label="Nome" value={form.nome} onChange={e => setForm(f => ({ ...f, nome: e.target.value }))} sx={{ mt: 1, mb: 2 }} />
          <TextField fullWidth label="Descrição" multiline rows={2} value={form.descricao} onChange={e => setForm(f => ({ ...f, descricao: e.target.value }))} sx={{ mb: 2 }} />
          <TextField fullWidth select label="Discipulador" value={form.discipulador_id} onChange={e => setForm(f => ({ ...f, discipulador_id: e.target.value }))} sx={{ mb: 2 }}>
            {discipuladores.map(d => <MenuItem key={d.id} value={d.id}>{d.nome}</MenuItem>)}
          </TextField>
          <TextField fullWidth label="Observações" value={form.observacoes} onChange={e => setForm(f => ({ ...f, observacoes: e.target.value }))} />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDialog(false)}>Cancelar</Button>
          <Button variant="contained" onClick={salvar}>Salvar</Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
}
